import * as React from 'react';
import './Dropdown.scss';

export interface IOption {
  label: string;
  value: string | number;
  disabled?: boolean;
}

interface IDropdownProps {
  options: IOption[];
  onSelected: (itemValue: string) => void;
  activeOption: string | number | null;
  disabled?: boolean;
}

const Dropdown: React.FC<IDropdownProps> = props => {
  const { options, onSelected, activeOption, disabled } = props;

  const handleChangeOption = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onSelected(e.target.value);
  };

  return (
    <div className="rp-dropdown-wrapper">
      <select
        name="dropdown"
        id="rp-dropdown"
        className="rp-dropdown"
        onChange={handleChangeOption}
        value={activeOption}
        disabled={disabled}
      >
        {options.map(option => {
          return (
            <option
              className="rp-dropdown-option"
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default Dropdown;
